import ContainerSignInPhone from "./Components/ContainerSignInPhone"
export default function SignInPhone() {
  return (
    <div className="relative flex justify-center items-center min-h-dvh bg-zi-bg1-light dark:bg-zi-bg1-dark">
      <ContainerSignInPhone text="ورود به حساب کاربری"/>
      <span className="hidden absolute w-full h-[1px] bottom-16 bg-zi-gradient-divider"></span>
    </div>
  )
}